/**
 * Lebensrad im Verlauf (F-02): je Bereich ein Streifen ueber die letzten 12
 * Bewertungen in der Farbe der Skala (D-04, Leitlinie 6) - derselbe Baustein
 * wie bei Journal und Reflexionen. Im Rueckblick fuer alle Bereiche, auf dem
 * Board nur fuer den einen.
 */
import { useLiveQuery } from 'dexie-react-hooks';

import { SkalaStreifen } from '@/ui/composites/SkalaStreifen';
import { useAreas } from '@/modules/areas/useAreas';
import { db } from '@/db/schema';
import { lebensradVerlauf } from '@/domain/stats';
import { formatDate, today } from '@/lib/datetime';
import type { ID, LifeWheelSnapshot } from '@/domain/types';

/** So viele Bewertungen zeigt der Verlauf. */
const ANZAHL = 12;

export function LebensradStreifen({ nurBereich }: { nurBereich?: ID }) {
  const areas = useAreas(Boolean(nurBereich))
    .filter((a) => (nurBereich ? a.id === nurBereich : a.lifeWheelEnabled));
  const alle = useLiveQuery(() => db.lifeWheel.toArray(), [], [] as LifeWheelSnapshot[]);
  const verlauf = lebensradVerlauf(alle, today(), ANZAHL);

  if (areas.length === 0) return null;
  if (verlauf.length === 0) return <p className="text-sm text-ink-faint">Noch keine Lebensrad-Bewertung – bewertet wird in der Monatsreflexion.</p>;

  return (
    <div className="flex flex-col gap-2.5">
      {areas.map((a) => {
        const zuletzt = [...verlauf].reverse().find((s) => typeof s.scores[a.id] === 'number')?.scores[a.id];
        return (
          <SkalaStreifen
            key={a.id}
            label={nurBereich ? `Lebensrad (letzte ${verlauf.length} Bewertungen)` : a.name}
            zusatz={zuletzt === undefined ? undefined : `zuletzt ${zuletzt}`}
            punkte={verlauf.map((s) => ({ key: s.id, titel: formatDate(s.date), wert: s.scores[a.id] }))}
          />
        );
      })}
    </div>
  );
}
